import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import router from '../router';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  strict: debug, // Striktna kontrola pouzivania mutations
  modules: { auth },
  state: {
    currentTraining: {},
    trainingUpdate: 0,
    dateFormat: 'DD.MM.YYYY',
    dateTimeFormat: 'DD.MM.YYYY - HH:mm',
    globalMessage: '', // At the moment SessionExpired
    globalErrorText: '',
    siteError: 0,
    windowSize: {
      x: 0,
      y: 0,
    },
  },
  mutations: {
    currentTraining(state, data) {
      state.currentTraining = data;
    },
    trainingUpdate(state, data) {
      state.trainingUpdate = data;
    },
    windowSize(state, data) {
      state.windowSize = data;
    },
    siteError(state, data) {
      state.siteError = data;
    },
    globalMessage(state, data) {
      state.globalMessage = data;
    },
    globalErrorText(state, data) {
      state.globalErrorText = data;
    },
  },
  actions: {
    catchErrHandler(context, err) {
      if (typeof err.response === 'undefined') {
        context.commit('globalErrorText', err);
      } else {
        switch (err.response.status) {
          case 401: {
            context.commit('siteError', 401);
            context.commit('globalMessage', 'Nesprávne jméno nebo heslo');
            break;
          }
          case 403: {
            // console.log('ERRlog', err.response.data);
            if (err.response.data.error !== undefined) {
              if (err.response.data.error === 'NOSESS') {
                context.commit('globalMessage', 'Vypršela platnost přihlášení');
                router.push('/');
                return;
              }
            }
            this.state.siteError = 403;
            context.commit('globalErrorText', err.response);
            // value.state.globalMessage = 'Vypršela platnost přihlášení';
            // router.push('/');
            break;
          }
          case 500: {
            context.state.siteError = 500;
            context.commit('globalErrorText', err.response);
            // value.state.globalMessage = 'Chyba komunikace!';
            // router.push('/');
            break;
          }
          default: {
            // this.state.globalErrorText = err.response;
            context.commit('globalErrorText', err.response);
            context.commit('globalMessage', err.response.status + ' - ' + err.response.data.message);
          }
        }
      }
    },
  },
});
